export default __webpack_public_path__ + "static/media/menu_top_users_okara.ca7ad2a1.svg";